<template>
    <div class="user-management">
      <h2>User Management</h2>
  
      <!-- ✅ Show "Add User" Button for Super Admin & Admin -->
      <button v-if="isSuperAdmin || isAdmin" @click="openUserModal(null)">
        ➕ Add User
      </button>
  
      <h3>Users List</h3>
      <p v-if="loading">⏳ Loading users...</p>
      <p v-if="errorMessage" class="error">{{ errorMessage }}</p>
  
      <table v-if="users.length">
        <thead>
          <tr>
            <th>Email</th>
            <th>pass</th>
            <th>Role</th>
            <th>Shop</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="user in users" :key="user.email">
            <td>{{ user.email }}</td>
            <td>{{ user.password || "N/A" }}</td>
            <td>{{ user.role }}</td>
            <td>{{ user.shopId || "N/A" }}</td>
            <td>
              <button @click="openUserModal(user)">✏️ Edit</button>
              <button v-if="isSuperAdmin" @click="removeUser(user.email)">🗑️ Delete</button>
            </td>
          </tr>
        </tbody>
      </table>
  
      <!-- ✅ User Modal for Adding/Editing -->
      <div v-if="showUserModal" class="modal">
        <div class="modal-content">
          <h3>{{ editingUser ? "Edit User" : "Add User" }}</h3>
  
          <label>Email:</label>
          <input v-model="userForm.email" type="email" required :disabled="editingUser" />
  
          <label>Role:</label>
          <select v-model="userForm.role">
            <option value="super_admin" v-if="isSuperAdmin">Super Admin</option>
            <option value="admin">Admin</option>
            <option value="sales">Sales</option>
            <option value="room">Room</option>
            <option value="user">User</option>
          </select>
  
          <label>Shop ID:</label>
          <input v-model="userForm.shopId" type="text" placeholder="Enter shop ID (for admin, sales, room)" />
  
          <button @click="saveUser">{{ editingUser ? "Update User" : "Add User" }}</button>
          <button @click="showUserModal = false">Cancel</button>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { auth,getDoc,doc,db } from "../firebase"; // Import the listener
  import { getUsers, addUser, updateUser, deleteUser } from "@/firebase/firebaseService";
  import {  onAuthStateChanged } from "firebase/auth";// getIdToken

  export default {
    data() {
      return {
        userorigin: null, // ✅ Store logged-in user
        user: {
        email: "",
        role: "",
        uid:"",
        shopId: "",
        userInfo: "",
        },
        users: [],
        userForm: {
          email: "",
          role: "user",
          shopId: "",
        },
        showUserModal: false,
        editingUser: null,
        isSuperAdmin: false,
        isAdmin: false,
        loading: false,
        errorMessage: "",
        token :"",
      };
    },
    methods: {
        async initializeFirebase() {
         this.auth = auth;
       
        },
        async checkAuthState() {
  onAuthStateChanged(this.auth, async (user) => {
    if (user) {
      this.userorigin = user; // ✅ Store user authentication object
      
      // ✅ Get user role & shop from ID token
      const idTokenResult = await user.getIdTokenResult(true);
      console.log("🛠️ User Role:", idTokenResult.claims.role || "Not Assigned");
      console.log("🛠️ Assigned Shop:", idTokenResult.claims.shopId || "None");

      this.user.role = idTokenResult.claims.role || "";
      this.user.shopId = idTokenResult.claims.shopId || null;
      this.user.email = user.email;

      if (this.user.role === "super_admin") {
        this.isSuperAdmin = true;
      }
      if (this.user.role === "admin") {
        this.isAdmin = true;
      }

      console.log("✅ Authenticated as:", this.user.email);
      
      // ✅ Fetch users only after authentication is confirmed
      await this.fetchUsers(); 
    } else {  
      console.log("User not authenticated. Redirecting to login...");
      this.$router.push("/"); // Redirect to login page if not logged in
    }
  });
}
,
    async fetchUserType() {
      try {
        this.loading = true;
        if (!this.user.email) {
          throw new Error("❌ No logged-in user.");
        }

        // ✅ Query Firestore Collection
        const userRef = doc(db, "users", this.user.email);
        const userSnap = await getDoc(userRef);

        if (userSnap.exists()) {
          const userData = userSnap.data();
          console.log("✅ Firestore Document Data:", userData); // ✅ Logs the entire object
          console.table(userData); // 📊 Nicely formatted table in Console

          this.user.role = userData.role;
          console.log("role "+  this.user.role);
          this.user.shopId = userData.shopId || null;
          console.log("shopId "+  this.user.shopId);
          if ( this.user.role === "super_admin"){
            this.adminEmail = this.user.email;
            this.isSuperAdmin = true;
          }
        } else {
          throw new Error("❌ No user data found.");
        }
      } catch (error) {
        console.error("❌ Error fetching user type:", error);
        this.errorMessage = "❌ Failed to fetch user data.";
      } finally {
        this.loading = false;
      }
    },
      async fetchUsers() {
        try {
          this.loading = true;
           // ✅ Get Firebase ID Token (Contains Custom Claims)
          this.token = await this.userorigin.getIdToken(true);
          console.log("🛠️ ID Token:", this.token); // ✅ Debugging Token Output

          this.users = await getUsers(this.token);
        } catch (error) {
          console.error("❌ Error fetching users:", error);
          this.errorMessage = "❌ Failed to load users.";
        } finally {
          this.loading = false;
        }
      },
      async fetchUserRole() {
        // Simulate role assignment - Replace with real authentication check
        const adminEmail = "teeyaibeef@gmail.com"; // Replace with actual logged-in admin email
        this.isSuperAdmin = adminEmail === "super_admin@example.com";
        this.isAdmin = adminEmail === "admin@example.com";
      },
      openUserModal(user) {
        if (user) {
          this.editingUser = user;
          this.userForm = { ...user };
        } else {
          this.editingUser = null;
          this.userForm = { email: "", role: "user", shopId: "" };
        }
        this.showUserModal = true;
      },
      async saveUser() {
        try {
          this.loading = true;
          
          if (this.editingUser) {
            await updateUser(this.userForm,this.userorigin.email);
          } else {
            await addUser(this.userForm,this.userorigin.email);
          }
          alert("✅ User saved successfully!");
          this.showUserModal = false;
          this.fetchUsers();
        } catch (error) {
          console.error("❌ Error saving user:", error);
          alert("❌ Failed to save user.");
        } finally {
          this.loading = false;
        }
      },
      async removeUser(email) {
        if (!confirm("❌ Are you sure you want to delete this user?")) return;
        try {
          await deleteUser(email);
          alert("✅ User deleted successfully!");
          this.fetchUsers();
        } catch (error) {
          console.error("❌ Error deleting user:", error);
          alert("❌ Failed to delete user.");
        }
      },
    },
    async mounted() {
        await this.initializeFirebase();
        await this.checkAuthState();
        await this.fetchUserRole();
        
    },
  };
  </script>
  
  <style scoped>
  .user-management {
    max-width: 600px;
    margin: auto;
    text-align: center;
  }
  
  button {
    background-color: #28a745;
    color: white;
    border: none;
    padding: 10px;
    cursor: pointer;
    margin: 5px;
  }
  
  button:hover {
    background-color: #218838;
  }
  
  button:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
  
  table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;
  }
  
  th, td {
    border: 1px solid #ddd;
    padding: 10px;
  }
  
  th {
    background-color: #f4f4f4;
  }
  
  .error {
    color: red;
    font-weight: bold;
  }
  
  .modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .modal-content {
    background: white;
    padding: 20px;
    border-radius: 5px;
    width: 300px;
  }
  </style>
  